module.exports = __webpack_public_path__ + "static/media/img_bg_login.51cc299d.jpg";